import React, { ErrorInfo, ReactNode } from "react";
import * as Sentry from "@sentry/react";

import { Error } from "src/components/error/error";

/*
 * Types
 */

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ErrorBoundaryProps {}

interface State {
    readonly hasError: boolean;
}

/*
 * Component
 */

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
    state: State = {
        hasError: false,
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static getDerivedStateFromError(_error: Error): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // if (process.env.NODE_ENV === "production") {
        Sentry.captureException(error);
        // }
        console.error(`[!] Error: ${error}\n[!] Info: ${errorInfo}`);
    }

    render(): ReactNode {
        const { children } = this.props as any;
        const { hasError } = this.state;

        return hasError ? <Error /> : children;
    }
}
